import { ThunkAction } from "redux-thunk";
import { RootState } from "../../store";
import { AnyAction } from "redux";
import {
  setErrorMessage,
  setSuccessMessage,
} from "../actionsCreators/messageActions";
import {
  DELETE_USER_SUCCESS,
  PAYMENT_CREATED,
  PAYMENT_POSTED,
  PAYMENT_UNPOSTED,
  PAYMENT_UPDATED,
} from "../../lib/constants";
import BatchPaymentsService from "../../services/processing/payments";
import { ReactNode } from "react";
import { getErrorMessages } from "../../lib/getErrorMessages";

const ERROR_TITLE =
  "There is an issue with this payment and the action was not successful.";

const CUSTOM_ERROR =
  'The action was not successful. There are issues in your data. Please fix affected Account ->Disbursements to have correct "Bank Account Number" and "Routing Number" and recreate the payment.';

const getOnError = (error: any): string | ReactNode => {
  const keys: string[] = Object.keys(error.response.data.errors || {});

  if (keys.length > 0) {
    const disbErrorLength: number = keys.map((item: string) =>
      item.includes("Disbursements")
    ).length;

    return disbErrorLength > 1
      ? CUSTOM_ERROR
      : getErrorMessages(error, ERROR_TITLE);
  } else {
    return error.response.data.title;
  }
};

export const deletePayment =
  (id: string): ThunkAction<void, RootState, unknown, AnyAction> =>
  async (dispatch) => {
    try {
      const res = await BatchPaymentsService.remove(id);

      dispatch(setSuccessMessage(DELETE_USER_SUCCESS));

      return await Promise.resolve(res);
    } catch (error: any) {
      dispatch(setErrorMessage(error.response.data.title, true));

      return await Promise.reject(error);
    }
  };

export const savePaymentAsDraft =
  (
    request: any,
    showMessage: boolean
  ): ThunkAction<void, RootState, unknown, AnyAction> =>
  async (dispatch) => {
    try {
      const res = await BatchPaymentsService.saveAsDraft(request);

      showMessage && dispatch(setSuccessMessage(PAYMENT_CREATED));

      return await Promise.resolve(res);
    } catch (error: any) {
      dispatch(setErrorMessage(getOnError(error), true));

      return await Promise.reject(error);
    }
  };

export const updatePayment =
  (
    id: string,
    request: any,
    showMessage: boolean
  ): ThunkAction<void, RootState, unknown, AnyAction> =>
  async (dispatch) => {
    try {
      const res = await BatchPaymentsService.update(id, request);

      showMessage && dispatch(setSuccessMessage(PAYMENT_UPDATED));

      return await Promise.resolve(res);
    } catch (error: any) {
      dispatch(setErrorMessage(getOnError(error), true));

      return await Promise.reject(error);
    }
  };

export const togglePayment =
  (
    id: string,
    isPost: boolean
  ): ThunkAction<void, RootState, unknown, AnyAction> =>
  async (dispatch) => {
    try {
      const res = await BatchPaymentsService.toggle(id, isPost);

      dispatch(setSuccessMessage(isPost ? PAYMENT_POSTED : PAYMENT_UNPOSTED));

      return await Promise.resolve(res);
    } catch (error: any) {
      dispatch(setErrorMessage(error.response.data.title, true));

      return await Promise.reject(error);
    }
  };

export const calculatePayment =
  (request: any): ThunkAction<void, RootState, unknown, AnyAction> =>
  async (dispatch) => {
    try {
      const res = await BatchPaymentsService.calculate(request);

      return await Promise.resolve(res);
    } catch (error: any) {
      dispatch(setErrorMessage(getOnError(error), true));

      return await Promise.reject(error);
    }
  };
